export default "__VITE_ASSET__DiX2CAov__"